import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { Observable } from "rxjs";

export interface HasPendingMessages {
  hasPendingMessages(): boolean;
}

@Injectable({
  providedIn: "root",
})
export class UserMessagesCanDeactivateGuard implements CanDeactivate<HasPendingMessages> {
  canDeactivate(component: HasPendingMessages): Observable<boolean> | boolean {
    if (component.hasPendingMessages()) {
      return false;
    }
    return true;
  }
}
